"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const white = '#FFFFFF';
const green = '#007833';
const lightGreen = '#A4F0C4';
const lightGrey = '#D2D2D2';
const glass = 'rgba(255, 255, 255, 0.2)';
const voucherStatus = '#CCCCEA';
const voucherText = '#353535';
// Primary
const pulseBlue = '#000096';
const pulseGreen = '#9BFF00';
const bpBlue = '#009EE0';
const bpGreen = '#009900';
// Secondary
const bpGrey = '#070C2E';
const bpLightBlue = '#E6E9FA';
// Blacks
const black = '#000000';
const black2 = '#1D1D26';
// Greys
const grey1 = '#212121';
const grey2 = '#5B5B5B';
const grey3 = '#AFAFAF';
const grey4 = '#DEDEDE';
const grey5 = '#F5F5F5';
const grey6 = '#8E8E92';
const grey7 = '#D8D8D8';
const grey8 = '#DDDDDD';
const grey9 = '#616365';
// States
const success = '#007F00';
const warning = '#FFBC3D';
const error = '#CF0001';
const successPale = '#E5F4E5';
const errorPale = '#FAE5E5';
const primary = pulseBlue;
const secondary = bpLightBlue;
const theme = {
    green,
    grey: grey9,
    lightGrey,
    glass,
    color: {
        primary,
        pulseGreen,
        bpBlue,
        bpGreen,
        black,
        black2,
        white,
        bpGrey,
        secondary,
        grey: {
            one: grey1,
            two: grey2,
            three: grey3,
            four: grey4,
            five: grey5,
            six: grey6,
            seven: grey7,
            eight: grey8,
            nine: grey9,
        },
        state: {
            success,
            successPale,
            warning,
            error,
            errorPale,
        },
    },
    text: {
        color: {
            primary: black,
            secondary: grey9,
            tertiary: primary,
            error,
            strongSecondary: grey9,
            pulseGreen,
            white,
        },
        body: {
            regular: {
                size: '12px',
                lineHeight: '15px',
            },
            large: {
                size: '15px',
                lineHeight: '21px',
            },
        },
    },
    background: {
        primary: white,
        secondary: bpLightBlue,
        tertiary: primary,
    },
    border: {
        color: {
            error,
        },
    },
    buttons: {
        primary: {
            background: primary,
            text: white,
        },
        secondary: {
            background: secondary,
            text: primary,
        },
        ghost: {
            background: glass,
            text: white,
        },
        text: {
            background: white,
            text: primary,
        },
        charge: {
            background: bpBlue,
            text: white,
        },
        danger: {
            background: error,
            text: white,
        },
        disabled: {
            background: '#D6D6D6',
            text: '#959595',
        },
        small: {
            background: white,
            text: primary,
        },
        cancel: {
            background: '#F5CCCC',
            text: '#CF0001',
        },
    },
    tags: {
        positive: {
            background: lightGreen,
            text: bpGreen,
        },
        neutral: {
            background: secondary,
            text: primary,
        },
        negative: {
            background: '#FFD1D1',
            text: error,
        },
        warning: {
            background: '#FFD7AD',
            text: error,
        },
        primary: {
            background: white,
            text: primary,
        },
        secondary: {
            background: secondary,
            text: primary,
        },
        tertiary: {
            background: '#E8E8E8',
            text: black,
        },
        error: {
            background: '#FFD1D1',
            text: error,
        },
        filter: {
            background: '#E8E8E8',
            text: black,
        },
        strike: {
            background: white,
            text: primary,
        },
        availablePrimary: {
            background: white,
            text: success,
        },
        availableSecondary: {
            background: lightGreen,
            text: green,
        },
        inUse: {
            background: grey8,
            text: black,
        },
        info: {
            background: white,
            text: black,
        },
        price: {
            background: white,
            text: primary,
        },
        speed: {
            background: white,
            text: grey6,
        },
    },
    card: {
        background: '#F4F4F4',
        border: '#EAEAEA',
        title: {
            size: '16px',
            lineHeight: '21px',
        },
        'text-large': {
            size: '16px',
            lineHeight: '24px',
        },
        'text-xl': {
            size: '18px',
            lineHeight: '19px',
        },
        'text-xxl': {
            size: '20px',
            lineHeight: '21px',
        },
        text: {
            size: '14px',
            lineHeight: '15px',
        },
        'text-small': {
            size: '10px',
            lineHeight: '12px',
        },
        'text-medium': {
            size: '14px',
            lineHeight: '20px',
        },
        textPressable: {
            size: '16px',
            lineHeight: '19px',
        },
    },
    switch: {
        disabledThumbColor: white,
        enabledThumbColor: white,
        disabledTrackColor: '#C8C8C8',
        enabledTrackColor: primary,
        onTintColor: white,
    },
    icons: {
        default: {
            color: black,
        },
        enabled: {
            color: primary,
        },
        disabled: {
            color: black,
        },
    },
    input: {
        primary: {
            background: white,
            color: black,
            border: `1px solid ${grey8}`,
            clearButtonColor: grey1,
        },
    },
    searchBar: {
        placeholderText: black,
        icons: black,
        color: '#DFE3E6',
    },
    selectItem: {
        enabled: {
            background: bpLightBlue,
            text: pulseBlue,
        },
        disabled: {
            background: white,
            text: pulseBlue,
        },
    },
    bottomNavigation: {
        background: white,
        enabled: {
            text: primary,
            icon: primary,
        },
        disabled: {
            text: grey9,
            icon: grey9,
        },
    },
    searchItem: {
        background: '#f9f9f9',
        title: black,
        description: grey9,
        distance: grey9,
    },
    paymentCards: {
        greyText: grey9,
        shadow: grey9,
    },
    errorNotification: {
        background: error,
        color: white,
    },
    footerBanner: {
        background: primary,
        color: white,
    },
    shadow: {
        default: {
            color: '#000000',
            opacity: 0.2,
            radius: '7px',
            elevation: 5,
        },
    },
    table: {
        border: grey7,
    },
    header: {
        background: white,
        border: '#f2f2f2',
        color: black,
    },
    gocardless: {
        button: {},
        text: {
            header: black2,
            banner: grey1,
            border: '#f2f2f2',
            cardtext: grey8,
        },
        page: {
            background: grey5,
        },
    },
    checkBox: {
        primary: {
            backgroundColor: white,
            tick: primary,
            borderColor: grey4,
            checked: {
                backgroundColor: white,
                borderColor: primary,
            },
        },
        secondary: {
            tick: primary,
            backgroundColor: primary,
            borderColor: white,
            checked: {
                backgroundColor: white,
                borderColor: grey4,
            },
        },
    },
    textInput: {
        color: black,
        backgroundColor: white,
        borderColor: grey4,
        borderRadius: '8px',
        clearButtonColor: grey1,
        labelTextColor: voucherText,
        assistiveTextColor: grey6,
        disabled: {
            color: voucherText,
            backgroundColor: grey5,
        },
        error: {
            backgroundColor: errorPale,
            color: error,
        },
        success: {
            backgroundColor: successPale,
            color: success,
        },
    },
    voucher: {
        color: {
            grey: grey6,
            status: voucherStatus,
            text: voucherText,
            active: bpGreen,
            activeuntil: black,
            expired: error,
        },
    },
    mapIcons: {
        buttonBorder: '#dfe3e6',
        item: {
            borderTop: grey8,
            typeText: black2,
            powerText: grey6,
        },
    },
    accountDashboard: {
        background: '#f9f9f9',
    },
    notification: {
        content: {
            primary: 'rgb(255,255,255)',
            success: 'rgb(17, 17, 17)',
        },
        background: {
            primary: 'rgb(0,0,0)',
            success: 'rgb(230, 255, 242)',
        },
        border: {
            primary: 'rgb(0,0,0)',
            success: 'rgb(46, 230, 140)',
        },
    },
};
exports.theme = theme;
